<ion-header>
    <ion-toolbar>
        <ion-title>{{'Widget Status' | translate}}</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="modalDissmissed()" fill="clear" color="dark">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list>
        <ion-item>
            <ion-label>{{ 'Enable Widget' | translate }}</ion-label>
            <ion-toggle 
                slot="end" 
                [checked]="isWidgetEnabled" 
                (ionChange)="onToggleChange($event)">
            </ion-toggle>
        </ion-item>

        @if (isWidgetEnabled) {
            <ion-item>
                <ion-textarea 
                    readonly 
                    [value]="widgetCodeSnippet"
                    class="code-snippet">
                </ion-textarea>
            </ion-item>
            <ion-item lines="none">
                <ion-button 
                    expand="block" 
                    (click)="copyCodeSnippet()"
                    color="primary">
                    <ion-icon slot="start" name="copy-outline"></ion-icon>
                    {{ 'Copy Snippet Code' | translate }}
                </ion-button>
            </ion-item>
        }
    </ion-list>
</ion-content>

